/**
 * Holds the current session bearer token for the API layer. Set once after the SDK connects
 * (useActivity), read by api.ts to attach `Authorization: Bearer <token>` on write/cost requests.
 *
 * Kept as a tiny module-level holder (not React state) so the plain `fetch` helpers in api.ts can
 * reach it without threading the token through every call site.
 */
let token: string | null = null;

export function setAuthToken(next: string | null): void {
  token = next;
}

export function getAuthToken(): string | null {
  return token;
}

/** Authorization header object (spread into fetch headers), or empty when there's no session yet. */
export function authHeader(): Record<string, string> {
  return token ? { Authorization: `Bearer ${token}` } : {};
}
